import { Table } from "react-bootstrap";
import { TableContainer } from "../../../@ui/TableContainer";
import { PaginationResult } from "../../../types/PaginiationResult";
import { WfsLog } from "../../../types/WfsLog/WfsLog";
import { GetAllWfsLogRequest } from "../../../types/WfsLog/GetAllWfsLogRequest";
import { ShrinkHeader } from "../../Table/ShrinkHeader";
import TableActionButton from "../../../@ui/TableActionButton";
import TableFooter from "../../Table/Footer";
import ParametersModal from "../../modal/RequestHistory/ParametersModal";
import { useState } from "react";

interface RequestHistoryTableProps {
    isAdmin: boolean;
    wfsLogs: PaginationResult<WfsLog>;
    filterRequest: GetAllWfsLogRequest;
    setCurrentPage: (page: number) => void;
    currentPage: number;
}

const RequestHistoryTable = ({isAdmin, wfsLogs, filterRequest, setCurrentPage, currentPage}:RequestHistoryTableProps) => {
  const [selectedParams, setSelectedParams] = useState<string>();
    return(<><TableContainer className="flex-grow mb-1">
        <Table striped bordered hover>
          <thead className="position-sticky">
            <tr>
              <th className="text-white bg-primary w-15">Date / Time</th>
              {isAdmin && <th className="text-white bg-primary">User</th>}
              <th className="text-white bg-primary">Data Size (MB)</th>
              <th className="text-white bg-primary">Response Time</th>
              <ShrinkHeader className="text-white bg-primary" />
            </tr>
          </thead>
          <tbody>
            {wfsLogs.items.map((wfsLog) => (
              <tr key={wfsLog.id}>
                <td>{wfsLog.createdDate.toFormat("dd/MM/yyyy, HH:mm:ss")}</td>
                <td>{wfsLog.user.username}</td>

                <td>{wfsLog.dataSize.toLocaleString()}</td>
                <td>{wfsLog.responseTime.toFixed(2).toLocaleString()}</td>
                <td>
                  <TableActionButton onClick={() => setSelectedParams(JSON.stringify(wfsLog.wfsParameters, null, 2))}>View</TableActionButton>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      <TableFooter
        setCurrentPage={setCurrentPage}
        totalItems={wfsLogs.totalItems}
        pageSize={filterRequest.count}
        currentPage={currentPage}
      />

      {
        selectedParams &&(
      <ParametersModal  params={selectedParams} onClose={() => setSelectedParams(undefined)} />)
      }
      </>
      );
};

export default RequestHistoryTable;